import React from "react";
import "./App.css";
import Barr from "./Barr"
import Footer from "./Footer"

function App() {
    return (
        <div className="App">
           <Barr/>
           <Footer/>
        </div>
    );
}

export default App;